import classNames from "classnames"
import { ReactElement } from "react"

interface LabelRowProps {
  label: string
  value: string | number | ReactElement
  className?: string
}
export const LabelRow = (props: LabelRowProps) => {
  const {label, value, className} = props
  let renderVal: any = value
  return <div className={classNames('flex-space-btw', 'mt-1', className)}>
    <div>{label}:</div>
    <div>{renderVal ?? '-'}</div>
  </div>
}